export default __webpack_public_path__ + "static/media/pgLogo.ebdd2a76.png";